import React, { useEffect, useRef, useState, useCallback } from "react";
import { createGame as createPacman } from "../games/pacman";
import { createGame as createSnake } from "../games/snake";

const hsKey = (id) => `zelt_hs_${id}`;

const TouchDpad = ({ onDir }) => {
  const btn =
    "w-14 h-14 rounded-xl bg-blue-900 text-white text-xl font-bold shadow-lg active:bg-teal-500 select-none flex items-center justify-center";
  return (
    <div
      className="grid grid-cols-3 gap-2 justify-items-center mt-3 lg:hidden"
      aria-label="Touch controls"
    >
      <span />
      <button className={btn} onClick={() => onDir("up")} aria-label="Move up">▲</button>
      <span />
      <button className={btn} onClick={() => onDir("left")} aria-label="Move left">◀</button>
      <button className={btn} onClick={() => onDir("down")} aria-label="Move down">▼</button>
      <button className={btn} onClick={() => onDir("right")} aria-label="Move right">▶</button>
    </div>
  );
};

const GameCard = ({ game }) => {
  const canvasRef = useRef(null);
  const instanceRef = useRef(null);
  const [score, setScore] = useState(0);
  const [highScore, setHighScore] = useState(
    Number(localStorage.getItem(hsKey(game.id)) || 0)
  );

  const mountGame = useCallback(() => {
    return game.create(canvasRef.current, {
      onScore: (s) => setScore(s),
      onGameOver: (finalScore) => {
        setHighScore((prev) => {
          if (finalScore > prev) {
            localStorage.setItem(hsKey(game.id), String(finalScore));
            return finalScore;
          }
          return prev;
        });
      },
    });
  }, [game]);

  useEffect(() => {
    const instance = mountGame();
    instanceRef.current = instance;
    return () => instance.destroy();
  }, [mountGame]);

  const restart = useCallback(() => {
    instanceRef.current?.destroy();
    instanceRef.current = mountGame();
  }, [mountGame]);

  const setDirection = useCallback(
    (dir) => instanceRef.current?.setDirection?.(dir),
    []
  );

  return (
    <div className="bg-black p-4 rounded-2xl shadow-2xl">
      <div className="bg-white rounded-xl p-4">
        <div className="flex justify-between items-center mb-3">
          <div>
            <h3 className="font-extrabold text-2xl text-blue-900">{game.name}</h3>
            <p className="text-gray-500 text-sm">{game.tagline}</p>
            <p className="text-gray-400 text-xs mt-1">{game.controls}</p>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-blue-900">{score}</div>
            <div className="text-xs text-gray-500">
              Best: <span className="text-teal-500 font-bold">{highScore}</span>
            </div>
          </div>
        </div>
        <canvas
          ref={canvasRef}
          className="w-full rounded-lg shadow-inner touch-none"
          tabIndex={0}
        />
        <TouchDpad onDir={setDirection} />
        <button
          onClick={restart}
          className="mt-3 text-white bg-blue-900 hover:bg-blue-800 w-full py-2 rounded-xl font-bold"
        >
          Restart
        </button>
      </div>
    </div>
  );
};

export default GameCard;
